import { TFunction } from 'i18next';
import { FiCountry } from '../../contexts/LocaleContext';
import { MakerItem } from './components/Maker/MakerTile';

const CA_EXCLUDED_MAKERS = new Set(['The French Dog', 'Little Bear Boutique', 'Taiga Dogs']);

export const getMakerItems = (t: TFunction, country: FiCountry): MakerItem[] => {
  const allMakers: MakerItem[] = [
    {
      title: 'Stunt Puppy',
      description: t('maker_description_stunt_puppy'),
      image: {
        type: 'image',
        url: '/fimakers/stunt_puppy_s3_1.png',
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: 'https://www.stuntpuppy.com/collections/fi-ready-collars',
    },
    {
      title: 'Mimi Green',
      description: t('maker_description_mimi_green'),
      image: {
        type: 'image',
        url: '/fimakers/mimi_green_s3_1.png',
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: 'https://www.shopmimigreen.com/fi-compatible-collars/',
    },
    {
      title: 'Lucky + Dog',
      description: t('maker_description_lucky_dog'),
      image: {
        type: 'image',
        url: '/fimakers/lucky_dog_s3_1.png',
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: 'https://luckyplusdog.com/collections/all-fi-collar-bands',
    },
    {
      title: 'Rope Hounds',
      description: t('maker_description_rope_hounds'),
      image: {
        type: 'image',
        url: '/fimakers/rope_hounds_s3_1.png',
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: 'https://ropehounds.com/collections/fi-collars?utm_source=Fi_Website&utm_medium=Website&utm_campaign=Fi_Collars',
    },
    {
      title: 'Modern Icon',
      description: t('maker_description_modern_icon'),
      image: {
        type: 'image',
        url: `/fimakers/modern_icon_s3_1.png`,
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: `https://www.modernicon.us/tryfi/`,
    },
    {
      title: 'Landshark Supply',
      description: t('maker_description_landshark_supply'),
      image: {
        type: 'image',
        url: '/fimakers/landshark_supply_s3_1.png',
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: 'https://landsharksupply.com/collections/fi-compatible?utm_source=Fi_Website&utm_medium=DirectLink&utm_campaign=Fi_Website',
    },
    {
      title: 'Duke & Fox',
      description: t('maker_description_duke_and_fox'),
      image: {
        type: 'image',
        url: '/fimakers/duke_and_fox_s3_1.png',
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: 'https://dukeandfox.com/collections/embroidered-dog-collars/products/personalized-fi-dog-collar',
    },
    {
      title: 'High Tail Hikes',
      description: t('maker_description_high_tail_hikes'),
      image: {
        type: 'image',
        url: '/fimakers/high_tail_hikes_s3_1.png',
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: 'https://hightailhikes.com/collections/fi-compatible-collars',
    },
    {
      title: `Elite Dog Gear`,
      description: t('maker_description_elite_dog_gear'),
      image: {
        type: 'image',
        url: `/fimakers/elite_dog_gear_s3_1.png`,
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: `https://elitedoggear.com/collections/fi-collars-1`,
    },
    {
      title: 'Mongrel + Mode',
      description: t('maker_description_mongrel_and_mode'),
      image: {
        type: 'image',
        url: '/fimakers/mongrel_and_mode_s3_1.png',
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: 'https://www.mongrelandmode.com/category/fi-compatible-collars',
    },
    {
      title: 'Zaley Designs',
      description: t('maker_description_zaley_designs'),
      image: {
        type: 'image',
        url: '/fimakers/zaley_designs_s3_1.png',
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: 'https://zaleydesigns.com/collections/fi-compatible-dog-collars',
    },
    {
      title: `Hypnotic Dog Co.`,
      description: t('maker_description_hypnotic_dog_co'),
      image: {
        type: 'image',
        url: `/fimakers/hypnotic_dog_s3_1.png`,
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: `https://hypnoticdog.co/pages/fi`,
    },
    {
      title: 'Vivid Canine',
      description: t('maker_description_vivid_canine'),
      image: {
        type: 'image',
        url: '/fimakers/vivid_canine_s3_1.png',
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: 'https://www.vividcanine.com/collections/fi-compatible-collars/Fi-Series-3',
    },
    {
      title: 'Champ Dog Gear',
      description: t('maker_description_champ_dog_gear'),
      image: {
        type: 'image',
        url: '/fimakers/champ_dog_gear_s3_1.png',
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: 'https://champdoggear.com/collections/fi-compatible',
    },
    {
      title: 'Alpinhound',
      description: t('maker_description_alpinhound'),
      image: {
        type: 'image',
        url: '/fimakers/alpinhound_s3_1.png',
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: 'https://alpinhound.com/collections/fi-collars',
    },
    {
      title: `Cookies & Co.`,
      description: t('maker_description_cookies_and_co'),
      image: {
        type: 'image',
        url: `/fimakers/cookies_and_co_s3_1.png`,
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: `https://cookiesandco.shop/collections/fi-compatible-collars/`,
    },
    {
      title: "Ruff N' Fluff",
      description: t('maker_description_ruff_n_fluff'),
      image: {
        type: 'image',
        url: '/fimakers/ruff_n_fluff_s3_1.png',
        retinaWidth: 1080,
        retinaHeight: 1064,
      },
      link: 'https://ruffnfluff.com/collections/fi-compatible-collars',
    },
    {
      title: 'Evergreen Dog Co.',
      description: t('maker_description_evergreen_dog_co'),
      image: {
        type: 'image',
        url: '/fimakers/evergreen_dog_co_s3_1.png',
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: 'https://evergreendogco.com/products/fi-compatible-biothane-dog-collars',
    },
    {
      title: `Atlas Pet Company`,
      description: t('maker_description_atlas_pet_company'),
      image: {
        type: 'image',
        url: `/fimakers/atlas_pet_co_s3_1.png`,
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: `https://atlaspetcompany.com/products/lifetime-pro-collar`,
    },
    {
      title: `ValorWearUSA`,
      description: t('maker_description_valor_wear_usa'),
      image: {
        type: 'image',
        url: `/fimakers/valor_wear_s3_1.png`,
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: `https://www.valorwearusa.com/product-page/fi-series-3-valor-adventure-collar-1-75`,
    },
    {
      title: 'Sexy Beast Dog Collars',
      description: t('maker_description_sexy_beast_dog_collars'),
      image: {
        type: 'image',
        url: '/fimakers/sexy_beast_s3_1.png',
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: 'https://sexybeastdogcollars.com/collections/fi-collar-bands',
    },
    {
      title: 'FKN Pretty',
      description: t('maker_description_fkn_pretty'),
      image: {
        type: 'image',
        url: '/fimakers/fkn_pretty_s3_1.png',
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: 'https://fknpretty.com/shop-1/ols/categories/fi-dog-collar',
    },
    {
      title: 'Beastly Moon',
      description: t('maker_description_beastly_moon'),
      image: {
        type: 'image',
        url: '/fimakers/beastly_moon_s3_1.png',
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: 'https://beastlymoon.com/',
    },
    {
      title: `SeaFlower Co.`,
      description: t('maker_description_seaflower_co'),
      image: {
        type: 'image',
        url: `/fimakers/seaflower_s3_1.png`,
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: `https://seaflowercompany.com/collections/fi-compatible-collars`,
    },
    {
      title: `Beau & Nora`,
      description: t('maker_description_beau_and_nora'),
      image: {
        type: 'image',
        url: `/fimakers/beau_nora_s3_1.png`,
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: `https://beauandnora.com/collections/fi-dogs-compatible-collars-collection`,
    },
    {
      title: `Pimped Out Pup`,
      description: t('maker_description_pimped_out_pup'),
      image: {
        type: 'image',
        url: `/fimakers/pimped_out_pup_s3_1.png`,
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: `https://www.pimpedoutpup.com/product-category/collars/fi3-compatible/`,
    },
    {
      title: `The French Dog`,
      description: t('maker_description_the_french_dog'),
      image: {
        type: 'image',
        url: `/fimakers/the_french_dog_s3_1.png`,
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: `https://www.etsy.com/shop/TheFrenchDog?utm_source=google&utm_medium=cpc&utm_campaign=Search_US_DSA_GGL_ENG_Pets_Categories_All&utm_ag=Dog%252BCollars&utm_custom1=_k_CjwKCAiAq4KuBhA6EiwArMAw1A_p3exrosvniB8f_4BCi_QjjWsOGHrdr9IvdZmSKlrfCIBYTj0f3xoCBosQAvD_BwE_k_&utm_content=go_1875987786_71100484318_544453585894_dsa-463558451496_c_&utm_custom2=1875987786&gad_source=1&gclid=CjwKCAiAq4KuBhA6EiwArMAw1A_p3exrosvniB8f_4BCi_QjjWsOGHrdr9IvdZmSKlrfCIBYTj0f3xoCBosQAvD_BwE&section_id=33233619`,
    },
    {
      title: `Pawsome Tails`,
      description: t('maker_description_pawsome_tails'),
      image: {
        type: 'image',
        url: `/fimakers/pawsome_tails_s3_1.png`,
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: `https://www.pawsometailsco.com/collections/fi-compatible-collars`,
    },
    {
      title: `Merely Mavy`,
      description: t('maker_description_merely_mavy'),
      image: {
        type: 'image',
        url: `/fimakers/merely_mavy_s3_1.png`,
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: `https://merelymavy.com/collections/stickers`,
    },
    {
      title: `Guardian Gear`,
      description: t('maker_description_guardian_gear'),
      image: {
        type: 'image',
        url: `/fimakers/guardian_gear_s3_1.png`,
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: `https://www.guardian--gear.com/collars`,
    },
    {
      title: `Hoot & Co`,
      description: t('maker_description_hoot_and_co'),
      image: {
        type: 'image',
        url: `/fimakers/hoot_and_co_s3_1.png`,
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: `https://www.hootandco.com/collections/fi-collars?gad_source=1&gclid=Cj0KCQjwxeyxBhC7ARIsAC7dS39o0cF9ygGEAJIESC6Tt3gKA6wggxxrcX5t0qiE0NcbuHjULDW_GEwaAsirEALw_wcB`,
    },
    {
      title: 'Harbour Hound',
      description: t('maker_description_harbour_hound'),
      image: {
        type: 'image',
        url: `/fimakers/harbour_hound_s3_1.jpg`,
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: `https://harborhoundco.com/collections/fi-compatible-collars`,
    },
    {
      title: 'Major Darling',
      description: t('maker_description_major_darling'),
      image: {
        type: 'image',
        url: `/fimakers/major_darling_s3_1.jpg`,
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: `https://majordarling.com/collections/fi-compatible-collars`,
    },
    {
      title: 'Oliver & Ash',
      description: t('maker_description_oliver_and_ash'),
      image: {
        type: 'image',
        url: `/fimakers/oliver_and_ash_s3_1.jpg`,
        retinaWidth: 1080,
        retinaHeight: 1080,
      },
      link: `https://www.oliverandashdesigns.com/shop/p/the-fi-compatible-collection`,
    },
    {
      title: 'Bob & Bean',
      description: t('maker_description_bob_and_bean'),
      image: {
        type: 'image',
        url: `/fimakers/bob_and_bean_s3_1.png`,
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: `https://bobndbean.com/collections/fi-collection`,
    },
    {
      title: 'Para Meraki',
      description: t('maker_description_para_meraki'),
      image: {
        type: 'image',
        url: `/fimakers/para_meraki_s3_1.png`,
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: `https://www.parameraki.com`,
    },
    {
      title: 'Dog Goods for Good Dogs',
      description: t('maker_description_dog_goods_for_good_dogs'),
      image: {
        type: 'image',
        url: `/fimakers/dog_goods_for_good_dogs_s3_1.png`,
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: `https://doggoodsforgooddogs.com`,
    },
    {
      title: 'Dogistry',
      description: t('maker_description_dogistry'),
      image: {
        type: 'image',
        url: `/fimakers/dogistry_s3_1.png`,
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: `https://dogistry.com/collections/dogistry-x-fi-luxury-series-3-gps-compatible-dog-collars/Fi`,
    },
    {
      title: 'Honey Stone Co.',
      description: t('maker_description_honey_stone_co'),
      image: {
        type: 'image',
        url: `/fimakers/honey_stone_co_s3_1.png`,
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: `https://honeystoneco.com/products/braided-fi-collar`,
    },
    {
      title: 'Taiga Dogs',
      description: t('maker_description_taiga_dogs'),
      image: {
        type: 'image',
        url: `/fimakers/taiga_dogs_s3_1.png`,
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: `https://taigadogs.com/collections/collars`,
    },
    {
      title: 'Willadore Collar Co.',
      description: t('maker_description_willadore_collar_co'),
      image: {
        type: 'image',
        url: `/fimakers/willadore_s3_1.png`,
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: `https://willadoreco.com/collections/fi-collection`,
    },
    {
      title: 'Tactipup',
      description: t('maker_description_tactipup'),
      image: {
        type: 'image',
        url: `/fimakers/tactipup_s3_1.png`,
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: `https://www.tactipup.com/collections/fi-compatible-collars`,
    },
    {
      title: 'Crew LaLa',
      description: t('maker_description_crew_lala'),
      image: {
        type: 'image',
        url: `/fimakers/crew_lala_s3_1.png`,
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: `https://www.crewlala.com/pages/fi-compatible-collars`,
    },
    {
      title: 'The Eclectic Hound',
      description: t('maker_description_the_eclectic_hound'),
      image: {
        type: 'image',
        url: `/fimakers/the_eclectic_hound_s3_1.png`,
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: `https://theeclectichound.etsy.com`,
    },
    {
      title: 'Little Bear Boutique',
      description: t('maker_description_little_bear_boutique'),
      image: {
        type: 'image',
        url: `/fimakers/little_bear_boutique_s3_1.png`,
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: `https://shoplittlebear.square.site/shop/fi-compatible-collars/CINFRLSVZPEMHWOAOMF2WAEO`,
    },
    {
      title: 'Cross Winds Leather',
      description: t('maker_description_cross_winds_leather'),
      image: {
        type: 'image',
        url: `/fimakers/cross_winds_leather_s3_1.png`,
        retinaWidth: 1060,
        retinaHeight: 660,
      },
      link: `https://crosswindsleather.com/collections/fi-compatible-leather-collars`,
    },
  ];

  if (country === FiCountry.CA) {
    return allMakers.filter((maker) => !CA_EXCLUDED_MAKERS.has(maker.title));
  }

  return allMakers;
};
